const INSERIR_LISTA_ROTAS = (state, payload) => {
    state.items = payload
}

const BUSCANDO = (state, payload) => {
    state.buscando = payload
}

const LISTAR_SUBMODULOS = (state, payload) => {
    state.submodulos = payload
}

const DELETAR_LISTA_ROTA = (state, payload) => {
    state.items = state.items.filter(item => item.id !== payload.id)
}

const INSERIR_ROTA = (state, payload) => {
    state.items.push(payload)
}

const ATUALIZAR_ROTA = (state, payload) => {
    state.items = state.items.map(rota => {
        if (rota.id === payload.id) return payload;
        return rota;
    })
}

export {
    INSERIR_LISTA_ROTAS,
    BUSCANDO,
    LISTAR_SUBMODULOS,
    DELETAR_LISTA_ROTA,
    INSERIR_ROTA,
    ATUALIZAR_ROTA
}